import { Form, Select } from "antd"
import { states } from "../../constants/enrollmentForm"

const State = () => {
  return (
    <Form.Item
      rules={[
        {
          required: true,
          message: "Please enter a state",
        },
      ]}
      name="state"
      label="State"
    >
      <Select
        showSearch
        filterOption={(input, option) =>
          (option?.value ?? "")
            .toLowerCase()
            .includes(input.toLowerCase().trim())
        }
        options={states}
        virtual={false}
        // @ts-ignore
        autoComplete="new-password"
      />
    </Form.Item>
  )
}

export default State
